<template>
  <div class="outer-container">
    <Menu v-if="!getKiosk" :collapseMenu="$route.path === '/store'" />
    <div :id="getKiosk || getSatellite ? 'koiskCont' : 'content'"><slot /></div>
  </div>
</template>

<script>
import Menu from "@/components/_layouts/Menu";
import { mapGetters } from "vuex";
import dataMixin from "@/components/_mixins/dataMixin";
import { createdMixin } from "@monolith/mixins";

export default {
  components: { Menu },
  name: "Authenticated",
  computed: {
    ...mapGetters({
      loading: "loading",
      getKiosk: "getKiosk",
      getSatellite: "getSatellite",
      getHours: "getHours",
    }),
  },
  mixins: [dataMixin, createdMixin],
  watch: {
    getHours() {
      if (this.getHours) {
        this.$hours.popHours(this.getHours);
      }
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.outer-container {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: calc(100vh);

  #content {
    width: 100vw;
    margin-left: 5rem;
  }

  #kioskCont {
    width: 100vw;
    margin-left: 0rem;
  }
}

.header {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--banner-colour);
  color: #eeeff1;
  justify-content: center;
}

@media only screen and (orientation: portrait) {
  .outer-container {
    flex-direction: column;

    #content {
      margin-left: 0rem;
    }
  }

  #menu {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
